<template lang="">
  <section>
    <div class="container mt-12 mb-48">
      <h1
        class="text-[#000] title-head font-bold text-[60px] font-Approach uppercase text-center"
      >
        Client <br />
        testimonial
      </h1>
    </div>
    <div class="bg-[#F0F0F0] py-16">
      <div class="container">
        <div class="row">
          <div
            class="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 gap-10 mt-[-120px]"
          >
            <div class="testimonial-card bg-white p-5 rounded-xl">
              <h1
                class="uppercase text-[#000] text-[23px] font-semibold font-Approach"
              >
                Testimonial Title
              </h1>
              <p class="text-[#000] mt-3">
                Lorem ipsum dolor sit amet, consectetur <br />
                adipiscing elit.
              </p>

              <div class="flex items-center mt-5 gap-4">
                <img
                  class="h-full rounded-full"
                  src="@/assets/images/Fadhila R..png"
                />
                <div>
                  <h4 class="text-[#000] font-medium">Customer Name</h4>
                  <p class="text-[#000] inline-flex">Fitness Coach</p>
                </div>
              </div>
            </div>
            <div class="testimonial-card bg-white p-5 rounded-xl">
              <h1
                class="uppercase text-[#000] text-[23px] font-semibold font-Approach"
              >
                Testimonial Title
              </h1>
              <p class="text-[#000] mt-3">
                Lorem ipsum dolor sit amet, consectetur <br />
                adipiscing elit.
              </p>

              <div class="flex items-center mt-5 gap-4">
                <img
                  class="h-full rounded-full"
                  src="@/assets/images/Tom b.png"
                />
                <div>
                  <h4 class="text-[#000] font-medium">Customer Name</h4>
                  <p class="text-[#000] inline-flex">Fitness Coach</p>
                </div>
              </div>
            </div>
            <div class="testimonial-card bg-white p-5 rounded-xl">
              <h1
                class="uppercase text-[#000] text-[23px] font-semibold font-Approach"
              >
                Testimonial Title
              </h1>
              <p class="text-[#000] mt-3">
                Lorem ipsum dolor sit amet, consectetur <br />
                adipiscing elit.
              </p>

              <div class="flex items-center mt-5 gap-4">
                <img
                  class="h-full rounded-full"
                  src="@/assets/images/Tom b.png"
                />
                <div>
                  <h4 class="text-[#000] font-medium">Customer Name</h4>
                  <p class="text-[#000] inline-flex">Fitness Coach</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "Testimonial-Component",
};
</script>
<style scoped>
.testimonial-card {
  box-shadow: 0 0 #0000, 0 0 #0000, inset 0 2px 4px #0000000d;
}
</style>
